import { render, staticRenderFns } from "./CandidateInterviewWrapper.vue?vue&type=template&id=778679fa&scoped=true"
import script from "./CandidateInterviewWrapper.vue?vue&type=script&lang=ts"
export * from "./CandidateInterviewWrapper.vue?vue&type=script&lang=ts"
import style0 from "./CandidateInterviewWrapper.vue?vue&type=style&index=0&id=778679fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778679fa",
  null
  
)

export default component.exports